import type { TScreenRotation } from '../models/screen-rotation'
import { AspectRatio } from '../database/custom-types/aspect-ratio'

function normalizeRotation(rotation: TScreenRotation | null | undefined): TScreenRotation {
  if (rotation === '0' || rotation === '90' || rotation === '180' || rotation === '270') {
    return rotation
  }
  return '0'
}

/** True when playback uses {@link playerViewportRotationClassObject} (90° / 270°), not inner CSS rotate. */
export function usesRssWallLogicalViewportRotation(
  screenRotation?: TScreenRotation | null
): boolean {
  const rotation = normalizeRotation(screenRotation ?? undefined)
  return rotation === '90' || rotation === '270'
}

/**
 * Coarse g1-wall layout bucket from viewport dimensions (0° / 180° playback paths).
 * Rotated players (90° / 270°) use a logical viewport shell and always get {@link AspectRatio.Vertical}.
 */
export function rssWallLayoutAspectFromViewport(
  widthPx: number,
  heightPx: number,
  screenRotation?: TScreenRotation | null
): AspectRatio {
  if (usesRssWallLogicalViewportRotation(screenRotation)) {
    return AspectRatio.Vertical
  }

  const w = Math.round(widthPx)
  const h = Math.round(heightPx)
  if (w <= 0 || h <= 0) {
    return AspectRatio.Horizontal
  }
  if (w === h) {
    return AspectRatio.Square
  }
  return h > w ? AspectRatio.Vertical : AspectRatio.Horizontal
}
